import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 55BADC53-06EE-4199-8761-80AF2240DE1D
 * name radio-fm
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/radio-fm.svg
 * tags
 * - Audio 
 */
export const RadioFmIcon = createSvgIcon(<><path d="M3,7V17H5V13H8V11H5V9H9V7H3M13,7A2,2 0 0,0 11,9V17H13V9H15V16H17V9H19V17H21V9A2,2 0 0,0 19,7H13Z" /></>, 'RadioFmIcon');
export default RadioFmIcon